// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"B1-z"};